<template>
<section class="main">
    <TheHeader />
    <div class="flex">
         <div class="main__content">
            <h1 class="title">Criador de Assinatura Focus Química / Galileos / Novera</h1> 

            <div class="botoes">
              <router-link to="/focus-matriz" class="btn btn__home">Focus Matriz</router-link>
              <router-link to="/focus-filial" class="btn btn__home">Focus Filial</router-link>
              <router-link to="/galileos" class="btn btn__home">Galileos</router-link>
              <router-link to="/novera" class="btn btn__home">Novera Cosméticos</router-link>
            </div>
        </div>
    </div>
      <TheFooter />
</section>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";

export default {
  name: "Home",
  components: {
    TheHeader,
    TheFooter,
  },
};
</script>

